const environment = {
    baseApiUrl: 'https://clubleo-back-8f1b7e515d52.herokuapp.com/',
    baseBooksUrl: 'https://clubleo-books-565aa3cd5255.herokuapp.com/'
}

export default environment;
